import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'digital-platform-sw-wizard-navigation',
  templateUrl: './wizard-navigation.component.html',
  styleUrls: ['./wizard-navigation.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
  ],
})
export class WizardNavigationComponent {
  @Input() public backLabel = 'Back';
  @Input() public nextLabel = 'Next';
  @Input() public backRouterLink: any[] | string | null | undefined = null;
  @Input() public nextRouterLink: any[] | string | null | undefined = null;
  @Input() public backDisabled: boolean | null = false;
  @Input() public nextDisabled: boolean | null = false;
  @Input() public showBack: boolean | null = true;
  @Input() public showNext: boolean | null = true;
  @Input() public showSpinner: boolean | null = false;
  @Output() public back = new EventEmitter<void>();
  @Output() public next = new EventEmitter<void>();

  public onBack() {
    this.back.emit();
  }

  public onNext() {
    this.next.emit();
  }
}
